<template>
  <div class="mt-[15px] sm:mt-[16px]">
    <label for="email">Choose your first publication on this subscription</label>
    <Field :name="'startMonth' + '-' + index" as="select" v-model="selectedValue"
           class="w-full border rounded-small shadow-gray pt-4 pb-[13px] px-[18px] text-base sm:text-xl border-charcoal placeholder:text-silver h-[49px] sm:h-[53px]">
      <option value="" :selected="true">Select A Date</option>
      <option v-for="item in hebDatesSelect" :key="item.id" :value="item.id">{{ item.label }}</option>
    </Field>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import IconCalendar from "@/components/icons/IconCalendar.vue";
import SharedSelect from "@components/reusable/SharedSelect.vue";
import {useSignUpCartsStore} from "@stores/sign-up-cart";
import {Field} from 'vee-validate'

export default defineComponent({
  components: {SharedSelect, IconCalendar, Field},
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  setup() {
    const isDivVisible = ref(false)
    const hebDatesSelect = ref<any>([])
    const signUp = useSignUpCartsStore()
    const selectedValue = ref<String|null>(null);

    onMounted(async () => {
      await signUp.fetchHebDates()
      signUp.hebSelect.forEach((date:any) => {
          const id = `${date.day}_${date.month}_${date.year}`;
          hebDatesSelect.value.push({
            id: id,
            label: date.name
          });

          if (date.default) {
            selectedValue.value = id;
          }
        }
      );
      if (!selectedValue.value) {
        selectedValue.value = hebDatesSelect.value[0].id;
      }
    })

    function toggleDivVisibility() {
      isDivVisible.value = !isDivVisible.value
    }

    return {
      selectedValue,
      isDivVisible,
      toggleDivVisibility,
      hebDatesSelect
    }
  }
})
</script>